import AmbireDevice from './AmbireDevice'

export default AmbireDevice
